import { render, staticRenderFns } from "./SelectorPeriodos.vue?vue&type=template&id=96e772b4"
import script from "./SelectorPeriodos.vue?vue&type=script&lang=js"
export * from "./SelectorPeriodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports